import ViewHeader from './view-header';

export default ViewHeader;
